<template>
  <!-- CPAP処方申込履歴 -->
  <div id="CpapEscrowRequestList">
    <section>
      <div id="container-center">
        <div class="labelTitle lable">院内在庫注文履歴検索</div>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>受付番号</th>
              <td>
                <input type="text" v-model="searchConditions.receiptNumber" />
              </td>
              <th>種別</th>
              <td>
                <select v-model="searchConditions.kind">
                  <option value=""></option>
                  <option
                    v-for="item in kindGroupMaster"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </td>
              <th>進捗状況</th>
              <td>
                <select v-model="searchConditions.progress">
                  <option value="[]"></option>
                  <option
                    v-for="item in progressList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </td>
              <th>医療機関</th>
              <td><input type="text" v-model="searchConditions.hospital" /></td>
            </tr>
            <tr>
              <th>機種</th>
              <td>
                <select id="model" name="機種" v-model="searchConditions.model">
                  <option value="[]"></option>
                  <option
                    v-for="model in modelList"
                    :value="model.itemCodes"
                    :key="model.itemCodes"
                  >
                    {{ model.itemName }}
                  </option>
                </select>
              </td>
              <th>シリアル</th>
              <td><input type="text" v-model="searchConditions.serial" /></td>
              <th>申込日</th>
              <td colspan="3">
                <input
                  v-model="searchConditions.applicationDateStart"
                  type="date"
                  style="width: 200px"
                />
                ～
                <input
                  v-model="searchConditions.applicationDateEnd"
                  type="date"
                  style="width: 200px"
                />
              </td>
            </tr>
          </table>
          <div class="searchButton-area">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
            <b-button class="backbutton is-primary" @click="back"
              >戻る</b-button
            >
          </div>
        </div>
        <!-- 外部ユーザー検索結果 -->
        <template v-if="isHospital || isDealer">
          <div class="result-area" v-if="data.length > 0">
            <div>
              <b-table
                id="requestFormListTable"
                :data="data"
                :paginated="isPaginated"
                per-page="100"
                pagination-position="both"
                default-sort="patientCode"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
              >
                <template slot-scope="props">
                  <b-table-column
                    field="receiptNumber"
                    label="受付番号"
                    width="100"
                    centered
                    sortable
                  >
                    <router-link
                      :to="{
                        name: 'CpapGuestEscrowRequestDetail',
                        params: {
                          receiptNumber: props.row.receiptNumber,
                          applicationDate: props.row.applicationDate,
                          instructionDate: props.row.instructionDate,
                          salesOfficeCode: props.row.salesOfficeCode,
                          salesStaffCode: props.row.salesStaffCode,
                          billingDestinationCode: props.row.billingDestinationCode,
                          divisionClass: props.row.divisionClass,
                          customerClass: props.row.customerClass,
                          shippingDate: props.row.shippingDate,
                          shippingCondition: props.row.shippingCondition,
                          specifiedDeliveryDate: props.row.specifiedDeliveryDate,
                          targetHospitalName: props.row.targetHospitalName,
                          deliveryTargetBranchOffice: props.row.deliveryTargetBranchOffice,
                          divisionName: props.row.divisionName,
                          ordererName: props.row.ordererName,
                          deliveryPostcode: props.row.deliveryPostcode,
                          deliveryAddress1: props.row.deliveryAddress1,
                          deliveryAddress2: props.row.deliveryAddress2,
                          deliveryAddress3: props.row.deliveryAddress3,
                          receiverName: props.row.receiverName,
                          deliveryPhoneNumber: props.row.deliveryPhoneNumber,
                          deliveryStatementComment1: props.row.deliveryStatementComment1,
                          deliveryStatementComment2: props.row.deliveryStatementComment2,
                          shippingMethod: props.row.shippingMethod,
                          senderType: props.row.senderType,
                          destinationClass: props.row.destinationClass,
                          escrowDeviceList: props.row.escrowDeviceList,
                          escrowMaskList: props.row.escrowMaskList  ,
                          escrowOptionItemList: props.row.escrowOptionItemList,
                          escrowBundleItemList: props.row.escrowBundleItemList,
                          status: props.row.status,
                          searchConditions: searchConditions,
                          escrowSearchFlag: true,
                          internalSearch: false,
                          medicalInstitutionName: props.row.medicalInstitutionName,
                        },
                      }"
                      ><a>{{ props.row.receiptNumber }}</a></router-link
                    >
                  </b-table-column>
                  <!-- <b-table-column
                    field="kind"
                    label="種別"
                    width="110"
                    sortable
                    >{{
                      props.row.kind | codeFilter(kindGroupMaster)
                    }}</b-table-column
                  >
                  <b-table-column
                    field="inspection"
                    label="機種"
                    width="180"
                    sortable
                    >{{
                      props.row.reportFormatType | getNameFilter(modelList)
                    }}</b-table-column
                  > -->
                  <b-table-column
                    field="serial"
                    label="注文者名"
                    width="150"
                    sortable
                    >{{ props.row.ordererName }}</b-table-column
                  >
                  <b-table-column
                    v-if="!isHospital"
                    field="receiverName"
                    label="納品先宛名"
                    width="230"
                    sortable
                    >{{ props.row.receiverName }}</b-table-column
                  >
                  <!-- <b-table-column
                    field="patientName"
                    label="患者名"
                    width="180"
                    sortable
                    >{{ props.row.patientName }}</b-table-column
                  > -->
                  <b-table-column
                    v-if="!isHospital"
                    field="branchOffice"
                    label="支店"
                    width="180"
                    sortable
                    >{{
                      props.row.branchOffice
                    }}</b-table-column
                  >
                  <b-table-column
                    v-if="!isHospital"
                    field="salesStaffName"
                    label="営業担当名"
                    width="110"
                    sortable
                    >{{ props.row.salesStaffName }}</b-table-column
                  >
                  <b-table-column
                    field="applicationDate"
                    label="申込日"
                    width="110"
                    sortable
                    centered
                    >{{ props.row.applicationDate }}</b-table-column
                  >
                  <b-table-column
                    field="status"
                    label="申込み状況"
                    width="200"
                    sortable
                    centered
                  >
                    <span :class="getCpapInnerStatusClass(props.row.status)">
                      {{ getCpapProgres(props.row.status, props.row.kind) }}
                    </span>
                  </b-table-column>
                  <!-- <b-table-column label="問い合わせ" width="80" centered>
                    <a :href="props.row.ref"><b-icon icon="email-outline" /></a>
                  </b-table-column> -->
                </template>
              </b-table>
            </div>
            <div>
              <b-button class="backbutton is-primary" @click="back"
                >戻る</b-button
              >
            </div>
          </div>
        </template>
        <!-- 内部ユーザー検索結果 -->
        <template v-else>
          <div class="result-area" v-if="data.length > 0">
            <div>
              <b-table
                id="requestFormListTable"
                :data="data"
                :paginated="isPaginated"
                per-page="100"
                pagination-position="both"
                default-sort="patientCode"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
              >
                <template slot-scope="props">
                  <b-table-column
                    field="receiptNumber"
                    label="受付番号"
                    width="100"
                    centered
                    sortable
                  >
                    <router-link
                      :to="{
                        name: 'CpapAgentEscrowRequestDetail',
                        params: {
                          receiptNumber: props.row.receiptNumber,
                          applicationDate: props.row.applicationDate,
                          instructionDate: props.row.instructionDate,
                          billingStartDate: props.row.billingStartDate,
                          salesOfficeCode: props.row.salesOfficeCode,
                          salesStaffCode: props.row.salesStaffCode,
                          billingDestinationCode: props.row.billingDestinationCode,
                          hospitalDepartmentCode: props.row.hospitalDepartmentCode,
                          divisionClass: props.row.divisionClass,
                          customerClass: props.row.customerClass,
                          shippingDate: props.row.shippingDate,
                          shippingCondition: props.row.shippingCondition,
                          specifiedDeliveryDate: props.row.specifiedDeliveryDate,
                          targetHospitalName: props.row.targetHospitalName,
                          deliveryTargetBranchOffice: props.row.deliveryTargetBranchOffice,
                          divisionName: props.row.divisionName,
                          ordererName: props.row.ordererName,
                          deliveryPostcode: props.row.deliveryPostcode,
                          deliveryAddress1: props.row.deliveryAddress1,
                          deliveryAddress2: props.row.deliveryAddress2,
                          deliveryAddress3: props.row.deliveryAddress3,
                          receiverName: props.row.receiverName,
                          deliveryPhoneNumber: props.row.deliveryPhoneNumber,
                          deliveryStatementComment1: props.row.deliveryStatementComment1,
                          deliveryStatementComment2: props.row.deliveryStatementComment2,
                          shippingMethod: props.row.shippingMethod,
                          senderType: props.row.senderType,
                          destinationClass: props.row.destinationClass,
                          escrowDeviceList: props.row.escrowDeviceList,
                          escrowMaskList: props.row.escrowMaskList  ,
                          escrowOptionItemList: props.row.escrowOptionItemList,
                          escrowBundleItemList: props.row.escrowBundleItemList,
                          status: props.row.status,
                          billComment: props.row.billComment,
                          memo: props.row.memo,
                          searchConditions: searchConditions,
                          escrowSearchFlag: true,
                          internalSearch: true,
                          delivaryTarget: props.row.delivaryTarget,
                          medicalInstitutionName: props.row.targetHospitalName,
                        },
                      }"
                      ><a>{{ props.row.receiptNumber }}</a></router-link
                    >
                  </b-table-column>
                  <!-- 検索結果に表示する項目について、フィリップスの回答待ちのため、仮でいくつか表示してその他はコメントアウト（202310丸山） -->
                  <!-- <b-table-column
                    field="kind"
                    label="種別"
                    width="110"
                    sortable
                    >{{
                      props.row.kind | codeFilter(kindGroupMaster)
                    }}</b-table-column
                  >
                  <b-table-column
                    field="inspection"
                    label="機種"
                    width="180"
                    sortable
                    >{{
                      props.row.reportFormatType | getNameFilter(modelList)
                    }}</b-table-column
                  > -->
                  <b-table-column
                    field="serial"
                    label="注文者名"
                    width="150"
                    sortable
                    >{{ props.row.ordererName }}</b-table-column
                  >
                  <b-table-column
                    v-if="!isHospital"
                    field="receiverName"
                    label="納品先宛名"
                    width="230"
                    sortable
                    >{{ props.row.receiverName }}</b-table-column
                  >
                  <!-- <b-table-column
                    field="patientName"
                    label="患者名"
                    width="180"
                    sortable
                    >{{ props.row.patientName }}</b-table-column
                  > -->
                  <b-table-column
                    v-if="!isHospital"
                    field="branchOffice"
                    label="支店"
                    width="180"
                    sortable
                    >{{
                      props.row.branchOffice
                    }}</b-table-column
                  >
                  <b-table-column
                    v-if="!isHospital"
                    field="salesStaffName"
                    label="営業担当名"
                    width="110"
                    sortable
                    >{{ props.row.salesStaffName }}</b-table-column
                  >
                  <b-table-column
                    field="applicationDate"
                    label="申込日"
                    width="110"
                    sortable
                    centered
                    >{{ props.row.applicationDate }}</b-table-column
                  >
                  <b-table-column
                    field="status"
                    label="申込み状況"
                    width="200"
                    sortable
                    centered
                  >
                    <span :class="getCpapInnerStatusClass(props.row.status)">
                      {{ getCpapStatus(props.row.status, props.row.kind) }}
                    </span>
                  </b-table-column>
                  <!-- <b-table-column label="問い合わせ" width="80" centered>
                    <a :href="props.row.ref"><b-icon icon="email-outline" /></a>
                  </b-table-column> -->
                </template>
              </b-table>
            </div>
            <div>
              <b-button class="backbutton is-primary" @click="back"
                >戻る</b-button
              >
            </div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>
<script>
import { role } from "@/components/mock/base/const.js";

export default {
  name: "CpapEscrowRequestList",
  // props: {
  //   data:null,
  // },
  methods: {
    back: function () {
      if (this.isHospital || this.isDealer) {
      this.$router.push({ name: "CpapRequestMenu" });
      } else {
      this.$router.push({ name: "CpapRequestHome" });
      }
    },
    print: function () {
      window.print();
    },
    doSearch: function () {
      var excuteApi = this.getCpapEscrowRequestListPOST;
      var successCallBack = this.getCpapEscrowRequestListPOSTSuccess;
      var errorCallBack = this.getCpapEscrowRequestListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCpapEscrowRequestListPOST: function (client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.progress = JSON.parse(obj.progress);
      obj.model = JSON.parse(obj.model);
      obj.belongsId = this.belongsId;
      return client.apis.externalCpap.getCpapEscrowRequestListPOST({
        body: obj,
      });
    },
    getCpapEscrowRequestListPOSTSuccess: function (result) {
      // 検索結果取得
      this.data = result.obj;
      var subject = encodeURI(
        "【問合せ】 <ここに件名を記載してください> Philips Care Portal"
      );
      for (var item of this.data) {
        // count++;
        var body = encodeURI(
          "\n【受付番号】" +
            item.receiptNumber +
            "\n【種別】CPAP" +
            this.getCpapKind(item.kind) +
            "\n\n【お問い合わせ内容】\n\n<ここにお問い合わせ内容を記載してください。>\n"
        );
        item.ref =
          "mailto:" +
          item.inqueryAddress +
          "?subject=" +
          subject +
          "&body=" +
          body;
      }
    },
    getCpapEscrowRequestListPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoicesList: async function () {
      this.modelList = this.getCpapMaster();
      this.progressList = this.getCpapProgressList();
    },
  },
  data() {
    const takeOverSearchParams = this.$route.params["searchConditions"];
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const roleId = userInfo.roleId;
    const userId = userInfo.id;
    const isHospital = roleId == role.role_hospital;
    const isDealer = roleId == role.role_dealer;
    const kindGroupMaster = this.getCpapKindList();
    let searchConditions = {
      receiptNumber: "",
      kind: "",
      progress: "[]",
      hospital: isHospital ? userInfo.medicalInstitutionName : "",
      patientRegistrationCard: "",
      patientName: "",
      patientNameKana: "",
      model: "[]",
      serial: "",
      applicationDateStart: "",
      applicationDateEnd: "",
      completionDateStart: "",
      completionDateEnd: "",
      approval: "",
    };
    return {
      takeOverSearchParams,
      searchConditions,
      data: [],
      roleId,
      userId,
      isHospital,
      isDealer,
      role,
      isPaginated: true,
      modelList: [],
      progressList: [],
      kindGroupMaster,
      belongsId: userInfo.belongsId,
    };
  },
  filters: {
    getNameFilter: function (val, list) {
      var target = list.find((item) => item.reportFormatType == val);
      if (target) {
        return target.itemName;
      }
      return "";
    },
    codeFilter(value, list) {
      var target = list.find((val) => val.code == value);
      if (target) {
        return target.name;
      }
      return "";
    },
  },
  components: {},
  async mounted() {
    // マスタ取得
    await this.getChoicesList();
    if (this.takeOverSearchParams) {
      this.searchConditions = this.takeOverSearchParams;
      this.doSearch();
    };
  },
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapEscrowRequestList.vue